// © Microsoft Corporation. All rights reserved.

/**
 * locationHref of page
 */
export const locationHref = (typeof (window) !== "undefined" ? window.location.href : "");

/**
 * Render-cache expiration time in ms
 * 86400000 = 24 hours in milliseconds
 */
export const defaultExpirationTimeMs = 86400000;

/**
 * Render-cache force expiration time in ms
 * 129600000 = 36 hours in milliseconds
 */
export const defaultForceExpirationTimeMs = 129600000;

/**
 * localStorage key prefix for render cache expiration timestamp
 * Stores the sliding window expiration
 */
export const expirationPrefix = "timestamp_";

/**
 * Force timestamp prefix for render cache values
 * Stores the absolute window expiration
 */
export const forceTimestampPrefix = "force_timestamp_";

/**
 * Jss map suffix for render cache values
 * Stores the jss class list map
 */
export const jssMapSuffix = "_jssMap";

/**
 * Prefix for render cache keys
 * Stores the collection of all render cache keys
 */
export const keysPrefix = "keys_";

/**
 * The key for storing all render cache normalized keys
 * Maintain a single entry for collection of all render cache keys
 * Example: for https://ntp.msn.com/edge/ntp?locale=en-us URL,
 * we have one key with all the following render cache keys values
 *
 *  key: keys_https://ntp.msn.com/edge/ntp?locale=en-us&startpage=1
 *  value: {
 *      keyn: "lastKnown_https://ntp.msn.com/edge/ntp?locale=en-us",        // render cache key
 *      expn: "timestamp_https://ntp.msn.com/edge/ntp?locale=en-us",        // expiration key
 *      frcn: "force_timestamp_https://ntp.msn.com/edge/ntp?locale=en-us",  // force timestamp key
 *      jssn: "lastKnown_https://ntp.msn.com/edge/ntp?locale=en-us_jssMap"  // jss map key
 *  }
 */
export const renderCacheKeyOfNormalizedKeys = `${keysPrefix}${locationHref}`;

/**
 * localStorage key prefix for render cache object
 * Stores the render cache snapshot
 */
export const storagePrefix = "lastKnown_";

/**
 * River Render Cache ClassName
 */
export const riverRcClassName = "river-rc";